import { render, staticRenderFns } from "./ModalResendApproval.vue?vue&type=template&id=0d56605f&"
import script from "./ModalResendApproval.vue?vue&type=script&lang=js&"
export * from "./ModalResendApproval.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src1477836768/src/github.com/FebosIO/Febos-AMI/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0d56605f')) {
      api.createRecord('0d56605f', component.options)
    } else {
      api.reload('0d56605f', component.options)
    }
    module.hot.accept("./ModalResendApproval.vue?vue&type=template&id=0d56605f&", function () {
      api.rerender('0d56605f', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/febos/chile/approvals/components/trays/managementTray/modals/ModalResendApproval.vue"
export default component.exports